import { useContext } from 'react'

import { ArrowLeft, ArrowRight } from '@hhgtech/icons/other'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { CarouselOrListingBlockContext } from '../context'
import { useSlideInfo } from '../useSlideInfo'

export const Arrows = ({ styles, classNames }: BoxProps) => {
  const { embla, filteredChild, showFullSlide } = useContext(
    CarouselOrListingBlockContext,
  )
  const { slideInfo } = useSlideInfo(embla, filteredChild.length)
  const { classes, cx } = useStyles(
    { showFullSlide },
    {
      name: 'CarouselOrListingBlock__Arrows',
      styles,
      classNames,
    },
  )

  return (
    <>
      <Box
        className={cx(
          'arrow',
          'arrow-prev',
          classes.arrow,
          classes.arrowPrev,
          slideInfo.canScrollPrev ? '' : 'disabled',
        )}
        onClick={() => embla?.scrollPrev()}
      >
        <ArrowLeft className={classes.arrowIcon} size={18} useCurrentColor />
      </Box>
      <Box
        className={cx(
          'arrow',
          'arrow-next',
          classes.arrow,
          classes.arrowNext,
          slideInfo.canScrollNext ? '' : 'disabled',
        )}
        onClick={() => embla?.scrollNext()}
      >
        <ArrowRight className={classes.arrowIcon} size={18} useCurrentColor />
      </Box>
    </>
  )
}
